import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getBufferReader } from './utils';
export function readStream(_x) {
  return _readStream.apply(this, arguments);
}
function _readStream() {
  _readStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var reader, doneStreaming, chunkBuffer, _yield$_awaitAsyncGen, value, done, processedChunks, _iterator, _step, chunk, jsonChunk, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          reader = getBufferReader(response);
          doneStreaming = false;
          chunkBuffer = '';
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return _awaitAsyncGenerator(reader.read());
        case 6:
          _yield$_awaitAsyncGen = _context.sent;
          value = _yield$_awaitAsyncGen.value;
          done = _yield$_awaitAsyncGen.done;
          doneStreaming = done;
          if (!value) {
            _context.next = 38;
            break;
          }
          processedChunks = "".concat(chunkBuffer).concat(value).split('\n'); // assumes that all JSON chunks are separated by a new-line;
          chunkBuffer = '';
          _iterator = _createForOfIteratorHelper(processedChunks);
          _context.prev = 14;
          _iterator.s();
        case 16:
          if ((_step = _iterator.n()).done) {
            _context.next = 30;
            break;
          }
          chunk = _step.value;
          _context.prev = 18;
          jsonChunk = JSON.parse(chunk);
          if (jsonChunk.type === 'ERROR') {
            reader.cancel();
          }
          _context.next = 23;
          return jsonChunk;
        case 23:
          _context.next = 28;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](18);
          // the chunk may be incomplete, so we'll save it for the next iteration.
          chunkBuffer = chunk;
        case 28:
          _context.next = 16;
          break;
        case 30:
          _context.next = 35;
          break;
        case 32:
          _context.prev = 32;
          _context.t1 = _context["catch"](14);
          _iterator.e(_context.t1);
        case 35:
          _context.prev = 35;
          _iterator.f();
          return _context.finish(35);
        case 38:
          _context.next = 48;
          break;
        case 40:
          _context.prev = 40;
          _context.t2 = _context["catch"](3);
          if (!(_context.t2 instanceof DOMException && _context.t2.name === 'AbortError')) {
            _context.next = 46;
            break;
          }
          doneStreaming = true;
          _context.next = 48;
          break;
        case 46:
          reader.cancel();
          throw _context.t2;
        case 48:
          if (!doneStreaming) {
            _context.next = 3;
            break;
          }
        case 49:
          if (!chunkBuffer) {
            _context.next = 52;
            break;
          }
          error = new Error("Not all the data was processed: ".concat(chunkBuffer));
          throw error;
        case 52:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 40], [14, 32, 35, 38], [18, 25]]);
  }));
  return _readStream.apply(this, arguments);
}